import http from "../../http-common";

class EventsSearchService {
    getEventsSearch(showOnlyPast:boolean, eventType: string, location: string, eventName: string, sortBy: number, pageSize: number, pageNumber: number, fromDate: string, toDate: string ) {
        return http.get(`/events-search?ShowOnlyPast=${showOnlyPast}&EventType=${eventType}&Location=${location}&EventName=${eventName}&SortBy=${sortBy}&PageSize=${pageSize}&PageNumber=${pageNumber}&fromDate=${fromDate}&toDate=${toDate}`);
    }
}

export default new EventsSearchService();
